import type { PageContent } from "../types";

export const p_introduction_of_mum_and_passage_ranking: PageContent = {
  slug: "introduction-of-mum-and-passage-ranking",
  title: `Introduction of MUM and Passage Ranking | Phil Carr SEO Consultant`,
  description: `In 2021, Google announced the Multitask Unified Model (MUM), an advanced algorithm designed to understand information across multiple modalities—text, images, and eventually video and audio.…`,
  date: "",
  lastUpdated: "2026-05-13",
  body: `# Introduction of MUM and Passage Ranking

![Introduction of MUM and Passage Ranking featured image](/images/blog/generated/introduction-of-mum-and-passage-ranking.jpg)

**Published:** June 15, 2021

What Is MUM?

In 2021, Google announced the Multitask Unified Model (MUM), an advanced algorithm designed to understand information across multiple modalities—text, images, and eventually video and audio. MUM aims to answer complex, multifaceted questions by drawing from diverse data sources and languages.

It is trained on a much larger dataset than previous models and can transfer knowledge across languages, providing more comprehensive answers to users.

## Passage Ranking Explained

Around the same time, Google introduced passage ranking, enabling it to identify and rank specific sections of a page rather than evaluating the entire page as a whole. This means that if a long article contains a concise answer to a query buried in the middle, that passage can still surface in search results.

This shift encourages writers to organise content with clear headings and coherent paragraphs that address individual subtopics.

## Implications for Content Creators

To optimise for MUM and passage ranking, structure your content thoughtfully. Use descriptive headings, create distinct sections for each question or topic, and write in a way that’s easy for algorithms to parse.

Including multimedia—images, audio snippets, charts—can also make your pages more appealing to MUM’s multimodal capabilities. When answering complex questions, provide context and break down the problem into manageable parts.

Doing so helps search engines surface the most relevant passages, and it makes your articles more useful for readers who skim for specific information.

## SEO Takeaways and Next Steps

MUM and passage ranking are significant leaps toward more intelligent search. By creating structured, comprehensive content and leveraging multimedia, you position your site to take advantage of these advancements.

If you’d like assistance in organising your content for these emerging technologies, contact info@phil‑carr.co.uk or 01226 697 325.

If you need help with your SEO strategy, get in touch by emailing [info@phil-carr.co.uk](mailto:info@phil-carr.co.uk) or calling 01226 697 325.

## Update — May 2026

Refreshed in May 2026 to reflect how AI Overviews now show for a wider share of informational queries in the UK. The tactics below still apply — clear question-and-answer structure and strong entity signals — but the citation share has shifted toward brands with visible expertise pages.

## About the author

Phil Carr is an SEO consultant and web strategist focused on helping businesses
grow through technical optimisation, content strategy, and data-driven decision making. His
work combines hands-on experience with ongoing research into algorithm updates and emerging
search trends.

[Read Phil’s bio](/#authorModal)

## Other News Articles

[![2024 Algorithm Updates – Navigating a Year of Core Changes and Spam Crackdowns featured image](/images/blog/generated/2024-algorithm-updates-navigating-a-year-of-core-changes-and-spam-crackdowns.jpg)](/blog/2024-algorithm-updates-navigating-a-year-of-core-changes-and-spam-crackdowns)

### [2024 Algorithm Updates – Navigating a Year of Core Changes and Spam Crackdowns](/blog/2024-algorithm-updates-navigating-a-year-of-core-changes-and-spam-crackdowns)

[![2023 SEO Lessons and Forward View featured image](/images/blog/generated/2023-seo-lessons-and-forward-view.jpg)](/blog/2023-seo-lessons-and-forward-view)

### [2023 SEO Lessons and Forward View](/blog/2023-seo-lessons-and-forward-view)

[![A Practical Plan for AI-Driven Search – A Ninety Day Playbook featured image](/images/blog/generated/a-practical-plan-for-ai-driven-search-a-ninety-day-playbook.jpg)](/blog/a-practical-plan-for-ai-driven-search-a-ninety-day-playbook)

### [A Practical Plan for AI-Driven Search – A Ninety Day Playbook](/blog/a-practical-plan-for-ai-driven-search-a-ninety-day-playbook)

[![Looking Ahead: Lessons from 2024 for the Future featured image](/images/blog/generated/looking-ahead-lessons-from-2024-for-the-future.jpg)](/blog/looking-ahead-lessons-from-2024-for-the-future)

### [Looking Ahead: Lessons from 2024 for the Future](/blog/looking-ahead-lessons-from-2024-for-the-future)

We use cookies to improve your experience, analyse site traffic, and understand how you interact with
our content. Read our [cookie policy](/cookies) to learn more.

Reject optionalAccept cookies [Privacy policy](/privacy-policy)

reCAPTCHA

Recaptcha requires verification.

protected by **reCAPTCHA**`,
};
